import { DataType } from "../../../../form/typings";
import { styleControlOptions } from "../../../../form/component-schema";
import i18n from "../../../i18n";
export default {
    $id: "Modifier",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        mappings: {
            type: DataType.String,
            title: i18n.t('dataitem.Mapping').toString(),
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
